export default __webpack_public_path__ + "697a22954910f06dad88ef2b71148dc8.png";